la-table-of-contents-controller {
  * {
    box-sizing: border-box;
  }

  .search {
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .search__input {
    flex: 1;
  }

  .search__clear-btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }

  .toggle {
    margin-bottom: 5px;
  }

  .toggle__expand-all-btn {
    margin-right: 5px;
  }
}
